import * as types from '../constants/action-types';
const generalInitialState = { locale: null };
export const generalReducer = (state = generalInitialState, action) => {
    switch (action.type) {
        case types.SET_LOCALE: {
            return { locale: action.payload };
        }
        case types.RESET: {
            return generalInitialState;
        }
        default:
            return state;
    }
};
export default generalReducer;
